import ApiRequest, { type AxiosResponse } from '@frontend/request';

import storage, { EStorageKey } from '@aqx-core/common/storage';

import { checkForDownload } from '../utils/export';

export * from './types';
export * from './message';

const request = new ApiRequest({
  onRequest: (configs) => {
    const url = configs.url || '';
    const token = storage.getItem(EStorageKey.TOKEN) as string;

    const axiosBaseConfigs = {
      ...configs
    };

    if (token) {
      if (['/api/support/v1/ticket'].includes(url)) {
        axiosBaseConfigs.headers['Authorization'] = `Bearer ${token}`;
        axiosBaseConfigs.headers['Accept'] = 'application/json';
        axiosBaseConfigs.headers['Content-Type'] = 'multipart/form-data';
      } else if (!['/api/auth/v1/company/login'].includes(url)) {
        axiosBaseConfigs.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return axiosBaseConfigs;
  },
  onResponse: (response: AxiosResponse) => {
    // Automatically check for file downloads in all responses
    checkForDownload(response);
  }
});

export { request };
